export function adjustPopoverPosition(popoverEl, anchorPoint, offset = 8, margin = 12) {
  if (!popoverEl || !anchorPoint) return null;

  const { innerWidth, innerHeight } = window;
  const rect = popoverEl.getBoundingClientRect();

  const deflectX = anchorPoint.deflectX || 0;
  const deflectY = anchorPoint.deflectY || 0;

  let baseX = anchorPoint.x;
  let baseY = anchorPoint.y;

  let tentativeX = baseX + deflectX;
  let tentativeY = baseY + deflectY;

  let top = tentativeY + offset;
  let left = tentativeX + offset;

  let didFlipY = false;
  let didFlipX = false;

  if (top + rect.height + margin > innerHeight) {
    top = baseY - rect.height - offset;
    didFlipY = true;
  }

  if (left + rect.width + margin > innerWidth) {
    left = baseX - rect.width - offset;
    didFlipX = true;
  }

  // If NOT flipped, apply deflects
  if (!didFlipY) {
    top = baseY + offset + deflectY;
  }

  if (!didFlipX) {
    left = baseX + offset + deflectX;
  }

  // Clamp to viewport with margin
  top = Math.max(margin, Math.min(top, innerHeight - rect.height - margin));
  left = Math.max(margin, Math.min(left, innerWidth - rect.width - margin));

  return { top, left };
}
